export const formatDate = (timestamp: string): string => {
  if (!timestamp) return "-";
  return new Date(timestamp).toLocaleDateString("hu-HU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};
